import { unref } from 'vue';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';

export function useTicketBulkActions(fetchTickets) {
  const store = useStore();
  const { t } = useI18n();

  const selectedTicketIds = useMapGetter('bulkActions/getSelectedTicketIds');

  function selectTicket(displayId) {
    store.dispatch('bulkActions/setSelectedTicketIds', displayId);
  }

  function deselectTicket(displayId) {
    store.dispatch('bulkActions/removeSelectedTicketIds', displayId);
  }

  function clearSelectedTickets() {
    store.dispatch('bulkActions/clearSelectedTicketIds');
  }

  function selectAllTickets(tickets, checked) {
    const ticketList = unref(tickets);
    if (checked) {
      store.dispatch(
        'bulkActions/setSelectedTicketIds',
        ticketList.map(ticket => ticket.display_id)
      );
    } else {
      clearSelectedTickets();
    }
  }

  function isTicketSelected(displayId) {
    return selectedTicketIds.value.includes(displayId);
  }

  async function onAssignTeam(team) {
    try {
      await store.dispatch('bulkActions/process', {
        type: 'Ticket',
        ids: selectedTicketIds.value,
        fields: {
          team_id: team.id === 0 || team.id === '0' ? 0 : team.id,
        },
      });
      clearSelectedTickets();
      useAlert(t('BULK_ACTION.TEAMS.ASSIGN_SUCCESFUL'));
      if (typeof fetchTickets === 'function') {
        fetchTickets();
      }
    } catch (err) {
      useAlert(t('BULK_ACTION.TEAMS.ASSIGN_FAILED'));
    }
  }

  async function onAssignAgent(agent) {
    try {
      await store.dispatch('bulkActions/process', {
        type: 'Ticket',
        ids: selectedTicketIds.value,
        fields: {
          assignee_id: agent.id ?? null,
        },
      });
      clearSelectedTickets();
      useAlert(t('BULK_ACTION.AGENTS.ASSIGN_SUCCESFUL'));
      if (typeof fetchTickets === 'function') {
        fetchTickets();
      }
    } catch (err) {
      useAlert(t('BULK_ACTION.AGENTS.ASSIGN_FAILED'));
    }
  }

  return {
    selectedTicketIds,
    selectTicket,
    deselectTicket,
    clearSelectedTickets,
    selectAllTickets,
    isTicketSelected,
    onAssignTeam,
    onAssignAgent,
  };
}
